import { FC, useEffect } from "react";
import { RouteObject, useRoutes } from 'react-router-dom'
import Articles from '@/pages/articles'
import ArticleList from '@/pages/articles/article-list'
import ArticleDetail from '@/pages/articles/article-detail'

// The articles section runs under a BrowserRouter (real paths: /articles/:id),
// while the rest of the main site runs under the HashRouter (域名/#/xxx).
// Any path that is not an articles path is a main-site destination, so we hand
// it back to the hash-routed main site with a full page load.
const RedirectToMain: FC = () => {
  useEffect(() => {
    const { pathname, search } = window.location;
    window.location.replace(`/#${pathname}${search}`);
  }, []);
  return null;
};

export const routes: RouteObject[] = [
  {
    path: "/articles",
    element: <Articles />,
    children: [
      {
        path: "",
        element: <ArticleList />,
      },
      {
        path: ":id?",
        element: <ArticleDetail />,
      },
    ],
  },
  {
    path: "*",
    element: <RedirectToMain />,
  },
];

const ArticlesRouter: FC = () => {
  return useRoutes(routes);
};

export default ArticlesRouter;
